'use strict';

(function () {
    'use strict';

    angular.module('zp').factory('GeolocationModel', geolocationModelFactory);

    function geolocationModelFactory() {

        function GeolocationModel() {

            this.address = null;
            this.city = null;
            this.country = null;
            this.longitude = null;
            this.latitude = null;
        }

        return GeolocationModel;
    }
})();